// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from '@firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyA7fH5eBNPTw9z6DrSiw2Q3-M4OrkXk_Vc',
  authDomain: 'expressions-111.firebaseapp.com',
  projectId: 'expressions-111',
  storageBucket: 'expressions-111.appspot.com',
  messagingSenderId: '703836026807',
  appId: '1:703836026807:web:a195268b4fe1e801335a32',
  measurementId: 'G-02NFVSRNG5',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
export default db;
